import Vue from 'vue'
import Vuex from 'vuex'
import { dataService } from '../services/data.service';
import { GET_SATCONTENT, GET_SATCONTENTACTION, GET_NOTIFICATIONS, GET_NOTIFICATIONSACTION, SAVE_NOTIFICATION, SAVE_NOTIFICATIONACTION, GET_SATSAVEDDATA, GET_SATSAVEDDATAACTION } from './mutation-types';
import { account } from './account.module';
import { users } from './users.module';
import { alert } from './alert.module';
import { util } from './util.module';
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

const state = {
  satContent: {},
  notifications: [],
  satSavedData: {},
  unsavedChanges: false
};

const mutations = {
  [GET_SATCONTENT](state, satContent){
    state.satContent = satContent;
  },

  [GET_SATSAVEDDATA](state, satSavedData){
    state.satSavedData = satSavedData;
  },
  
  [GET_NOTIFICATIONS](state, notifications){
    state.notifications = notifications;
  },

  setUnsavedChanges(state, unsavedChanges) {
    state.unsavedChanges = unsavedChanges;
  },

  [SAVE_NOTIFICATION](/* state, notifications */){
    //removed mutation as was breaking app and isn't needed here
    //state.notifications = notifications;
  }
};

const actions = {
  async [GET_SATCONTENTACTION]({commit}) {
    const satContent = await dataService.getSatContent();
    commit(GET_SATCONTENT, satContent);
  },

  async [GET_SATSAVEDDATAACTION]({commit}, satId) {
    const satSavedData = await dataService.getSatSavedData(satId);
    commit(GET_SATSAVEDDATA, satSavedData);
  },

  async [GET_SATSAVEDDATAACTION]({commit}, satId) {
    const satSavedData = await dataService.getSatSavedData(satId);
    commit(GET_SATSAVEDDATA, satSavedData);
  },

  async [GET_NOTIFICATIONSACTION]({commit}) {
    const notifications = await dataService.getNotificationsData();
    commit(GET_NOTIFICATIONS, notifications);
  },

  async [SAVE_NOTIFICATIONACTION]({commit}, notificationId) {    
    await dataService.saveViewedNotification(notificationId);
    //removed mutation as was breaking app and isn't needed here
    //const notifications = await dataService.saveViewedNotification(notificationId);
    commit(SAVE_NOTIFICATION);
  },

  async saveAssessmentsAction({ dispatch }, satContent) {
    try {      
      await dataService.saveAssessments(satContent);      
      await dispatch(GET_SATCONTENTACTION);
    } catch (error) {
      dispatch("alert/error", dataService.errorResponseHandler(error), { root: true });
    }
  },

  async deleteAssessmentResponsesAction({ dispatch }, satId) {
    try {      
      await dataService.deleteAssessmentResponses(satId); 
    } catch (error) {
      dispatch("alert/error", dataService.errorResponseHandler(error), { root: true });
    }
  },

  setUnsavedChangesAction({ commit }, unsavedChangesValue) {
    commit(this.setUnsavedChanges, unsavedChangesValue)
  }
};

const getters = {
  getSatContent: state => state.satContent,
  getSatById: (state) => (id) => {
    if(state.satContent.Tools){
      return state.satContent.Tools.find(x => x.Id == id)
    } else {
      [GET_SATCONTENTACTION];
      return {}
    }
  },
  getRoles: state => state.satContent.Roles,
  getNotifications: state => state.notifications,
  getSatStandard: (state) => (standardId) => {
    return (state.satSavedData && state.satSavedData.Standards) 
      ?
      state.satSavedData.Standards.filter(standard => {return standard.Id === standardId})[0]
      :{}
  }
};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    alert,
    account,
    users,
    util
},
plugins: [createPersistedState()]
})
